import { get as lodashGet } from 'lodash';
import { atom, MutableSnapshot, selector } from 'recoil';
import { Context } from '../../types';

export const contextState = atom<Context | undefined>({
  default: undefined,
  key: 'contextStateState',
});

export const accessTokenInvalidatedState = atom<boolean>({
  default: false,
  key: 'accessTokenInvalidatedState',
});

export const accessTokenSelector = selector<Context['accessToken'] | undefined>(
  {
    get: ({ get }) => {
      const context = get(contextState);
      return lodashGet(context, 'accessToken');
    },
    key: 'accessTokenSelector',
  },
);

export const sessionSelector = selector<Context['session'] | undefined>({
  get: ({ get }) => {
    const context = get(contextState);
    return lodashGet(context, 'session');
  },
  key: 'sessionSelector',
});

export const initializeState =
  (context: Context): ((mutableSnapshot: MutableSnapshot) => void) =>
  ({ set }) =>
    set(contextState, context);
